export default "__VITE_ASSET__Cc7vPW9s__"